import { IWobGliderBaseConstParam, WobGliderBase } from '@/models/wob//WobGliderBase'

export interface IWobGliderModEventConstParam extends IWobGliderBaseConstParam {
  modKey: string | null
  eventKey : string| null
}

export class WobGliderModEvent extends WobGliderBase {
  public modKey: string | null
  public eventKey: string | null

  constructor({ modKey,eventKey, ...args }: IWobGliderModEventConstParam) {
    super(args)
    this.modKey = modKey
    this.eventKey = eventKey
  }
}
